// removed by extract-text-webpack-plugin
module.exports = {"priceFilterSlider":"OYlmF","slider":"_3ZhXr","label":"sHUHv","minPriceLabel":"_1Pspt sHUHv","maxPriceLabel":"bWrym sHUHv"};


//////////////////
// WEBPACK FOOTER
// ./banquet/components/PriceFilterSlider/index.sass
// module id = 1497
// module chunks = 1